export {
  isProfileDocumentLabel,
  resolveProfileDocumentKey,
  normalizeDocumentFingerprint,
  isHospitalExtraExclusiveLabel,
} from "../constants/profileDocumentRegistry";

import { isProfileDocumentLabel } from "../constants/profileDocumentRegistry";

export const filterExtraDocumentsOnly = (
  docs: Array<string | null | undefined> | null | undefined,
): string[] => {
  if (!docs?.length) return [];

  const out: string[] = [];
  const seen = new Set<string>();

  for (const raw of docs) {
    const label = String(raw || "").trim();
    if (!label || isProfileDocumentLabel(label)) continue;
    const key = label.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(label);
  }

  return out;
};

/** Split a bullet list from email text into individual document labels. */
export const splitDocumentListText = (text: string): string[] => {
  return String(text || "")
    .split(/\n|[•·]|(?:\.\s+(?=[A-Z]))|(?:;\s+)/)
    .map((part) => part.replace(/^[\s\-–—*]+/, "").trim())
    .filter(Boolean);
};
